import type { ExhibitorStory } from '~/features/exhibitors'

type ExhibitorLocations = {
  [booth: string]: ExhibitorStory
}

/**
 * `location_booth` darf mehrere Standnummern enthalten ("2.14, 3.03"), wenn ein
 * Aussteller auf mehreren Standflaechen vertreten ist.
 */
export function useExhibitorLocations(exhibitors: ExhibitorStory[]): ExhibitorLocations {
  const locations = exhibitors.reduce<ExhibitorLocations>((accumulator, exhibitor) => {
    const booths = String(exhibitor.content.location_booth ?? '')
      .split(/[,;]/)
      .map((booth) => booth.trim())
      .filter(Boolean)

    booths.forEach((booth) => {
      accumulator[booth] = exhibitor
    })

    return accumulator
  }, {})

  return locations
}
